<div provide-parent-form class="playout-sharing">

	<bb-form-element [form]="form" [label]="'SHARING_OPTIONS' | translate">
		<div class="sharing-group">

			<bb-form-element [form]="form">
				<bb-check [(ngModel)]="playout.shareButtonEmbedCode" name="playout-shareButtonEmbedCode"
					[trueValue]="'true'" [falseValue]="'false'"></bb-check>
				<i class="fa fa-code"></i>
				{{ 'DIRECT_EMBED' | translate }}
			</bb-form-element>

			<bb-form-element [form]="form" *ngIf="use2018skin">
				<bb-check [(ngModel)]="playout.shareButtonDirectLink" name="playout-shareButtonDirectLink"
					[trueValue]="'true'" [falseValue]="'false'"></bb-check>
				<i class="fa fa-link"></i>
				{{ 'DIRECT_LINK' | translate }}
			</bb-form-element>

			<bb-form-element [form]="form">
				<bb-check [(ngModel)]="playout.shareButtonEmail" name="playout-shareButtonEmail" [trueValue]="'true'"
					[falseValue]="'false'"></bb-check>
				<i class="fa fa-envelope"></i>
				{{ 'EMAIL' | translate }}
			</bb-form-element>

			<bb-form-element [form]="form">
				<bb-check [(ngModel)]="playout.shareButtonFacebook" name="playout-shareButtonFacebook"
					[trueValue]="'true'" [falseValue]="'false'"></bb-check>
				<i class="fa-brands fa-facebook"></i>
				{{ 'FACEBOOK' | translate }}
			</bb-form-element>

			<bb-form-element [form]="form">
				<bb-check [(ngModel)]="playout.shareButtonLinkedIn" name="playout-shareButtonLinkedIn"
					[trueValue]="'true'" [falseValue]="'false'"></bb-check>
				<i class="fa fa-linkedin"></i>
				{{ 'LINKEDIN' | translate }}
			</bb-form-element>

			<bb-form-element [form]="form">
				<bb-check [(ngModel)]="playout.shareButtonPinterest" name="playout-shareButtonPinterest"
					[trueValue]="'true'" [falseValue]="'false'"></bb-check>
				<i class="fa fa-pinterest"></i>
				{{ 'PINTEREST' | translate }}
			</bb-form-element>

			<bb-form-element [form]="form">
				<bb-check [(ngModel)]="playout.shareButtonTwitter" name="playout-shareButtonTwitter"
					[trueValue]="'true'" [falseValue]="'false'"></bb-check>
				<i class="fa fa-twitter"></i>
				{{ 'TWITTER' | translate }}
			</bb-form-element>

			<bb-form-element [form]="form">
				<bb-check [(ngModel)]="playout.shareButtonWhatsApp" name="playout-shareButtonWhatsApp"
					[trueValue]="'true'" [falseValue]="'false'"></bb-check>
				<i class="fa fa-whatsapp"></i>
				{{ 'WHATSAPP' | translate }}
			</bb-form-element>

		</div>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'USE_DEEP_LINK_FOR_SOCIAL_SHARING_LINKS' | translate"
		[helpMessage]="'HELP.USE_DEEP_LINK_FOR_SOCIAL_SHARING_LINKS' | translate">
		<bb-check [(ngModel)]="playout.useDeeplinkForFacebook" name="playout-useDeeplinkForFacebook"
			[trueValue]="'true'" [falseValue]="'false'"></bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" [label]=" 'SHARE_TEXT' | translate">
		<input [(ngModel)]="playout.shareText" type="text" name="playout-shareText">
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'PLAYOUT_USED_FOR_SHARING' | translate"
		[helpMessage]="'HELP.PLAYOUT_USED_FOR_SHARING' | translate">
		<bb-entity-selector [(ngModel)]="playout.sharePlayout" name="playout-sharePlayout" [entityType]="'playout'"
			[extendable]="false" [filterSet]="[{
				filters: [{
					type: 'playout',
					field: 'status',
					operator: 'isNot',
					value: 'inactive'
				}]
			}]"></bb-entity-selector>
	</bb-form-element>

</div>
